export function formatCallupDateLabel(dateStr: string, timezone?: string | null): string {
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  const timeZone = timezone || undefined;
  return d.toLocaleDateString("es-ES", {
    weekday: "short",
    day: "numeric",
    month: "short",
    timeZone,
  });
}

export function formatCallupTimeLabel(dateStr: string, timezone?: string | null): string {
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  const timeZone = timezone || undefined;
  return d.toLocaleTimeString("es-ES", {
    hour: "2-digit",
    minute: "2-digit",
    timeZone,
  });
}

export function formatCallupFullLabel(dateStr: string, timezone?: string | null): string {
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  const timeZone = timezone || undefined;
  const weekday = d.toLocaleDateString("es-ES", { weekday: "long", timeZone });
  const dayMonth = d.toLocaleDateString("es-ES", { day: "numeric", month: "long", timeZone });
  const time = d.toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit", timeZone });
  const capitalizedWeekday = weekday.charAt(0).toUpperCase() + weekday.slice(1);
  return `${capitalizedWeekday} ${dayMonth}, ${time}`;
}
